import i18n from "../i18n";

// Tab labels are read when they are shown, so they follow the website's language
// (admin:tabs.*); value and name (the permission) do not change.
export const initialShippmentsTab = [
  {
    get label() {
      return i18n.t("admin:tabs.allCarriers");
    },
    value: "all",
    style: { fontWeight: "bold" },
    name: "shipper.access.shipment.view.all.carriers",
  },
  {
    get label() {
      return i18n.t("admin:tabs.hajexCarriers");
    },
    value: "Hajex",
    style: { fontWeight: "bold" },
    name: "shipper.access.shipment.view.hajex.carriers",
  },
  {
    get label() {
      return i18n.t("admin:tabs.customCarriers");
    },
    value: "Custom",
    style: { fontWeight: "bold" },
    name: "shipper.access.shipment.view.custom.carriers",
  },
  {
    get label() {
      return i18n.t("admin:tabs.truckers");
    },
    value: "carrier",
    style: { fontWeight: "bold" },
    name: "shipper.access.shipment.view.truckers.carriers",
  },
];
export const initialInvoiceTab = [
  {
    get label() {
      return i18n.t("admin:tabs.allCarriers");
    },
    value: "all",
    style: { fontWeight: "bold" },
    name: "shipper.access.invoice.view.all.carriers",
  },
  {
    get label() {
      return i18n.t("admin:tabs.hajexCarriers");
    },
    value: "Hajex",
    style: { fontWeight: "bold" },
    name: "shipper.access.invoice.view.hajex.carriers",
  },
  {
    get label() {
      return i18n.t("admin:tabs.customCarriers");
    },
    value: "Custom",
    style: { fontWeight: "bold" },
    name: "shipper.access.invoice.view.custom.carriers",
  },
  {
    get label() {
      return i18n.t("admin:tabs.truckers");
    },
    value: "carrier",
    style: { fontWeight: "bold" },
    name: "shipper.access.invoice.view.truckers.carriers",
  },
];
export const initialPickupTab = [
  {
    get label() {
      return i18n.t("admin:tabs.allCarriers");
    },
    value: "all",
    style: { fontWeight: "bold" },
    name: "shipper.access.pickup.view.all.carriers",
  },
  {
    get label() {
      return i18n.t("admin:tabs.hajexCarriers");
    },
    value: "Hajex",
    style: { fontWeight: "bold" },
    name: "shipper.access.pickup.view.hajex.carriers",
  },
  {
    get label() {
      return i18n.t("admin:tabs.customCarriers");
    },
    value: "Custom",
    style: { fontWeight: "bold" },
    name: "shipper.access.pickup.view.custom.carriers",
  },
  {
    get label() {
      return i18n.t("admin:tabs.truckers");
    },
    value: "carrier",
    style: { fontWeight: "bold" },
    name: "shipper.access.pickup.view.truckers.carriers",
  },
];
export const initialTrackingTab = [
  {
    get label() {
      return i18n.t("admin:tabs.allCarriers");
    },
    value: "all",
    style: { fontWeight: "bold" },
    name: "shipper.access.tracking.view.all.carriers",
  },
  {
    get label() {
      return i18n.t("admin:tabs.hajexCarriers");
    },
    value: "Hajex",
    style: { fontWeight: "bold" },
    name: "shipper.access.tracking.view.hajex.carriers",
  },
  {
    get label() {
      return i18n.t("admin:tabs.customCarriers");
    },
    value: "Custom",
    style: { fontWeight: "bold" },
    name: "shipper.access.tracking.view.custom.carriers",
  },
  {
    get label() {
      return i18n.t("admin:tabs.truckers");
    },
    value: "carrier",
    style: { fontWeight: "bold" },
    name: "shipper.access.tracking.view.truckers.carriers",
  },
];
export const initialPackagesTab = [
  {
    get label() {
      return i18n.t("admin:tabs.packages");
    },
    value: 0,
    style: { fontWeight: "bold" },
    name: "shipper.access.product.view.packages",
  },
  {
    get label() {
      return i18n.t("admin:tabs.bundles");
    },
    value: 1,
    style: { fontWeight: "bold" },
    name: "shipper.access.product.view.bundles",
  },
];
export const initialPaymentTab = [
  {
    get label() {
      return i18n.t("admin:tabs.approved");
    },
    value: 0,
    style: { fontWeight: "bold" },
    name: "shipper.access.payment.view.approved",
  },
  {
    get label() {
      return i18n.t("admin:tabs.pending");
    },
    value: 1,
    style: { fontWeight: "bold" },
    name: "shipper.access.payment.view.pending",
  },
  {
    get label() {
      return i18n.t("admin:tabs.cardManagement");
    },
    value: 2,
    style: { fontWeight: "bold" },
    name: "shipper.access.payment.view.pending",
  },
];
export const initialProductTab = [
  {
    get label() {
      return i18n.t("admin:tabs.allProducts");
    },
    value: 0,
    style: { fontWeight: "bold" },
    name: "",
  },
  {
    get label() {
      return i18n.t("admin:tabs.productAdjustment");
    },
    value: 1,
    style: { fontWeight: "bold" },
    name: "",
  },
  {
    get label() {
      return i18n.t("admin:tabs.productCountStock");
    },
    value: 2,
    style: { fontWeight: "bold" },
    name: "",
  },
];
